import {
  ClearbitIdentity as ClearbitIcon,
  FacebookServices as FacebookIcon,
  G2Services as G2Icon,
  GoogleAdsServices as GoogleAdsIcon,
  GoogleAnalyticsServices as GoogleAnalyticsIcon,
  GoogleTagmanagerServices as GoogleTagmanagerIcon,
  HubspotServices as HubspotIcon,
  MarketoServices as MarketoIcon,
  SalesforceServices as PardotIcon,
  SalesforceServices as SalesforceIcon,
  SegmentServices as SegmentIcon,
  SlackServices as SlackIcon,
} from '@clearkit/icons';
import { capitalize } from 'lodash';
import { ReactNode } from 'react';

import { AccountConnectorServiceEnum } from '~/generated/graphql';

type allServiceTypes =
  | AccountConnectorServiceEnum
  | 'pardot'
  | 'google_analytics'
  | 'google_tag_manager'
  | 'google_ads'
  | 'clearbit_tag';

const iconWidth = 24;
const iconHeight = 24;
const iconAdditionalClasses = 'mr-5';

export function getIntegrationNameFromService(service: string) {
  if (service === AccountConnectorServiceEnum.Salesforcesandbox) {
    return AccountConnectorServiceEnum.Salesforce;
  }

  return service;
}

export function getIntegrationIcon(service: allServiceTypes) {
  switch (service) {
    case AccountConnectorServiceEnum.Salesforce:
      return (
        <SalesforceIcon
          className={iconAdditionalClasses}
          height={iconHeight}
          width={iconWidth}
        />
      );
    case AccountConnectorServiceEnum.Hubspot:
      return (
        <HubspotIcon
          className={iconAdditionalClasses}
          height={iconHeight}
          width={iconWidth}
        />
      );
    case AccountConnectorServiceEnum.Marketo:
      return (
        <MarketoIcon
          className={iconAdditionalClasses}
          height={iconHeight}
          width={iconWidth}
        />
      );
    case AccountConnectorServiceEnum.Slack:
      return (
        <SlackIcon
          className={iconAdditionalClasses}
          height={iconHeight}
          width={iconWidth}
        />
      );
    case 'pardot':
      return (
        <PardotIcon
          className={iconAdditionalClasses}
          height={iconHeight}
          width={iconWidth}
        />
      );
    case 'google_analytics':
      return (
        <GoogleAnalyticsIcon
          className={iconAdditionalClasses}
          height={iconHeight}
          width={iconWidth}
        />
      );
    case 'google_tag_manager':
      return (
        <GoogleTagmanagerIcon
          className={iconAdditionalClasses}
          height={iconHeight}
          width={iconWidth}
        />
      );
    case 'clearbit_tag':
      return (
        <ClearbitIcon
          className={iconAdditionalClasses}
          height={iconHeight}
          width={iconWidth}
        />
      );
    case 'google_ads':
      return (
        <GoogleAdsIcon
          className={iconAdditionalClasses}
          height={iconHeight}
          width={iconWidth}
        />
      );
    case AccountConnectorServiceEnum.Facebook:
      return (
        <FacebookIcon
          className={iconAdditionalClasses}
          height={iconHeight}
          width={iconWidth}
        />
      );
    case AccountConnectorServiceEnum.Segment:
      return (
        <SegmentIcon
          className={iconAdditionalClasses}
          height={iconHeight}
          width={iconWidth}
        />
      );
    case AccountConnectorServiceEnum.G2:
      return (
        <G2Icon
          className={iconAdditionalClasses}
          height={iconHeight}
          width={iconWidth}
        />
      );
    default:
      return null;
  }
}

export type IntegrationConfiguration = {
  accountConnector?: any;
  icon: ReactNode;
  configuredPath: string;
  service: AccountConnectorServiceEnum;
  name: string;
  disabled: boolean;
};

export function getIntegrationConfigs(
  integrations: AccountConnectorServiceEnum[],
  accountConnectors: any[],
  baseConfiguredPath: string,
): IntegrationConfiguration[] {
  return integrations.map((service) => {
    const matchingAc = accountConnectors.find((ac) => ac.service === service);
    return {
      accountConnector: matchingAc,
      icon: getIntegrationIcon(service),
      name: capitalize(service),
      configuredPath: `${baseConfiguredPath}/${service}`,
      service: service,
    } as IntegrationConfiguration;
  });
}
